module.exports = __webpack_public_path__ + "img/escola_alquimia_quantica_black.987f9e8b.png";